export const COMP_OFF_LEDGER_STATUS_LABEL = {
  credited: "Earned (available)",
  used: "Availed",
  expired: "Expired",
  eligible: "Pending credit approval",
  work_approved: "Pending credit approval",
  work_requested: "Pending work approval",
  rejected: "Rejected",
  cancelled: "Cancelled",
};

export const COMP_OFF_SOURCE_LABEL = {
  opening: "Opening / imported",
  weekly_off: "Weekly Off worked",
  holiday: "Holiday worked",
  extra_hours: "Extra hours",
};

export function formatCompOffStatus(row) {
  if (!row) return "—";
  if (row.expired && String(row.status) === "credited") return "Expired";
  return COMP_OFF_LEDGER_STATUS_LABEL[String(row.status || "")] || String(row.status || "—");
}

export function formatCompOffSource(sourceType) {
  const key = String(sourceType || "").toLowerCase();
  return COMP_OFF_SOURCE_LABEL[key] || sourceType || "—";
}

export function formatCompOffDate(value) {
  if (!value) return "—";
  const s = String(value).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return s;
  return `${m[3]}/${m[2]}/${m[1]}`;
}

export function formatCompOffDays(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
}

export function summarizeCompOffLedger(rows = []) {
  const list = Array.isArray(rows) ? rows : [];
  let earned = 0;
  let availed = 0;
  let available = 0;
  let expired = 0;
  list.forEach((row) => {
    const days = Number(row.creditDays || 0);
    const status = String(row.status || "");
    if (status === "used") availed += days;
    else if (status === "expired" || row.expired) expired += days;
    else if (status === "credited") {
      earned += days;
      available += Number(row.remainingDays ?? days);
    } else if (["eligible", "work_approved", "work_requested"].includes(status)) {
      earned += 0;
    }
  });
  const earnedLots = list.filter((r) =>
    ["credited", "used", "expired"].includes(String(r.status || ""))
  );
  earned = earnedLots.reduce((sum, r) => sum + Number(r.creditDays || 0), 0);
  return {
    lots: list.length,
    earned,
    availed,
    available,
    expired,
  };
}
